import { Flex, Typography } from 'front-commons/ds';
import { ReactNode } from 'react';

type Cell = {
	content: ReactNode;
	rowSpan?: number;
};

type TableRow = (Cell | null)[];

type TablePolicyProps = {
	rows: TableRow[];
	columns: string[];
	gridTemplateColumns?: string;
	showHeader?: boolean;
};

export function TablePolicy({ rows, columns, gridTemplateColumns, showHeader = true }: TablePolicyProps) {
	return (
		<Flex
			gap="0"
			raw={{
				width: '100%',
				display: 'grid',
				gridTemplateColumns: gridTemplateColumns || `repeat(${columns.length}, 1fr)`,
				border: '1px solid var(--border-primary)',
				borderRadius: '10px',
				overflow: 'hidden',
			}}
		>
			{showHeader &&
				columns.map((title, index) => (
					<Flex
						key={title}
						padding="10px"
						raw={{
							gridColumn: `${index + 1}`,
							backgroundColor: 'var(--surface-white)',
							borderRight: index < columns.length - 1 ? '1px solid var(--border-primary)' : undefined,
							borderBottom: '1px solid var(--border-primary)',
							boxSizing: 'border-box',
						}}
					>
						<Typography variant="Paragraph/Semibold">{title}</Typography>
					</Flex>
				))}

			{rows.map((row, rowIndex) => {
				const isEven = rowIndex % 2 === 0;
				const backgroundColor = isEven ? 'var(--surface-primary)' : 'var(--surface-white)';

				return row.map((cell, cellIndex) => {
					const isLastColumn = cellIndex === columns.length - 1;
					const isOverlappedByRowSpan = rows
						.slice(0, rowIndex)
						.some(
							(prevRow, prevIndex) =>
								prevRow[cellIndex]?.rowSpan && rowIndex < prevIndex + prevRow[cellIndex]!.rowSpan!,
						);

					if (!cell || isOverlappedByRowSpan) return null;

					return (
						<Flex
							key={`${rowIndex}-${cellIndex}`}
							raw={{
								gridRow: `span ${cell.rowSpan || 1}`,
								backgroundColor,
								padding: '8px',
								borderRight: isLastColumn ? undefined : '1px solid var(--border-primary)',
								alignItems: 'center',
							}}
						>
							{cell.content}
						</Flex>
					);
				});
			})}
		</Flex>
	);
}
